import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectActiveThemedEventInfo, selectThemedEvent, selectThemedEventPlayerReward, } from "../../selectors/selectEventInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { BigCharacter } from "../generic/big-character/BigCharacter";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionThemedEventCollectReward } from "./actionThemedEvent";
var rewardDialogImageClassName = "reward-dialog-background-img";
var DialogThemedEventRewardDOM = function (_a) {
    var themedEventInfo = _a.themedEventInfo, reward = _a.reward, onCollectClick = _a.onCollectClick, activeThemedEvent = _a.activeThemedEvent;
    if (!activeThemedEvent || themedEventInfo == undefined) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "reward-dialog-wrapper reward-dialog-wrapper__background flex flex--around" },
        React.createElement(BigCharacter, { name: themedEventInfo.character, className: "reward-dialog-character" }),
        React.createElement("div", { className: "flex flex--stacked" },
            React.createElement("div", { className: IdStyles.TutorialBalloon + " flex flex--stacked reward-dialog-balloon" },
                React.createElement(TextLoca, { id: IdLoca.congratulations, className: IdStyles.TextBoldPrimary }),
                React.createElement(TextLoca, { id: themedEventInfo.completedDescription, className: IdStyles.TextNormal })),
            React.createElement("div", { className: IdStyles.ThemedEventRewardBackground + " themed-event-reward-background__container flex flex--end" },
                React.createElement("div", { className: "themed-event themed-event-reward-" + themedEventInfo.name.toLowerCase() + " " + rewardDialogImageClassName },
                    React.createElement("span", { className: rewardDialogImageClassName + "-text " + IdStyles.TextPositive }, reward.amount)),
                React.createElement("div", { className: "button-ribbon" },
                    React.createElement(ButtonPrimary, { onClick: function () {
                            onCollectClick(reward.resourceId, Long.fromNumber(reward.amount));
                        } },
                        React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.category_couponShop })))))));
};
var mapState = function (state) { return ({
    activeThemedEvent: selectThemedEvent(state),
    reward: selectThemedEventPlayerReward(state),
    themedEventInfo: selectActiveThemedEventInfo(state),
}); };
var mapDispatch = function (dispatch) { return ({
    onCollectClick: function (rewardId, rewardAmount) {
        dispatch(actionModalClose(IdModal.ThemedEventReward));
        dispatch(actionThemedEventCollectReward(rewardId, rewardAmount));
    },
}); };
export var DialogThemedEventReward = connect(mapState, mapDispatch)(DialogThemedEventRewardDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/themed-events/DialogThemedEventReward.tsx
// module id = 2938
// module chunks = 3